import axios from 'axios';

import type { IUserSaveResponse, IUserSaveBody } from '@/app-package';

const save = async (id: string | undefined, user: IUserSaveBody) => {
  const url = `/user/${id || ''}`;

  const { data } = await axios.post<IUserSaveResponse>(url, user);

  return data;
};

export default save;
